import { useState, useMemo } from "react";

const MODULES = [
  { id: "crm",        name: "CRM & Prospection",         price: 25 },
  { id: "planning",   name: "Planning & RDV",             price: 19 },
  { id: "abo",        name: "Abonnements récurrents",     price: 19 },
  { id: "stocks",     name: "Stocks & Commandes",         price: 25 },
  { id: "ged",        name: "Espace documentaire (GED)",  price: 19 },
  { id: "analytique", name: "Comptabilité analytique",    price: 25 },
  { id: "budget",     name: "Budget & Prévisionnel",      price: 25 },
  { id: "expert",     name: "Espace expert-comptable",    price: 25 },
  { id: "ia",         name: "Analytique IA",              price: 39 },
  { id: "conformite", name: "Conformité & International", price: 15 },
];

const PROFILES = {
  "Artisan / Commerce":       ["crm","stocks","planning","budget"],
  "E-commerce":               ["abo","conformite","ia","ged"],
  "Distribution / Grossiste": ["stocks","conformite","budget"],
  "Agence / Services":        ["crm","abo","planning","expert"],
  "Freelance":                ["abo","planning","ged","expert"],
  "Agent commercial":         ["crm","planning","budget"],
  "Profession libérale":      ["planning","abo","expert","ged"],
  "Immobilier / SCI":         ["expert","budget"],
};

const SOCLE = 39;
const USER_PRICE = 9;
const SAT_PRICE  = 23;
const GRP_PRICE  = 59;
const MAX_EXTRA  = 7;

const S = {
  wrap:    { minHeight:"100vh", background:"var(--bg-primary)", color:"var(--text-primary)", padding:24, fontFamily:"inherit" },
  header:  { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 },
  title:   { fontSize:16, fontWeight:500, color:"var(--text-primary)", margin:0 },
  toggle:  { display:"flex", background:"var(--bg-card)", borderRadius:8, padding:3, gap:3 },
  btnOn:   { fontSize:12, padding:"5px 12px", borderRadius:6, border:"none", cursor:"pointer", fontWeight:500, background:"var(--accent)", color:"#fff" },
  btnOff:  { fontSize:12, padding:"5px 12px", borderRadius:6, border:"none", cursor:"pointer", fontWeight:500, background:"transparent", color:"var(--text-muted)" },
  label:   { fontSize:10, fontWeight:500, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8, display:"block" },
  profiles:{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:20 },
  profOn:  { fontSize:12, padding:"5px 12px", borderRadius:999, border:"1px solid rgba(26,158,114,0.4)", background:"rgba(26,158,114,0.12)", color:"var(--accent)", cursor:"pointer" },
  profOff: { fontSize:12, padding:"5px 12px", borderRadius:999, border:"1px solid var(--border)", background:"var(--bg-card)", color:"var(--text-muted)", cursor:"pointer" },
  grid:    { display:"grid", gridTemplateColumns:"1fr 240px", gap:16, alignItems:"start" },
  card:    { background:"var(--bg-card)", border:"1px solid var(--border)", borderRadius:10, padding:"12px 14px", marginBottom:10 },
  modGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:6 },
  modOn:   { display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:8, border:"1px solid rgba(26,158,114,0.35)", background:"#0d2a1e", cursor:"pointer" },
  modOff:  { display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:8, border:"1px solid var(--border)", background:"var(--bg-card)", cursor:"pointer" },
  chkOn:   { width:16, height:16, borderRadius:4, background:"var(--accent)", border:"1px solid var(--accent)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  chkOff:  { width:16, height:16, borderRadius:4, background:"transparent", border:"1px solid var(--border)", flexShrink:0 },
  sumCard: { background:"#1F2428", border:"1px solid rgba(255,255,255,0.07)", borderRadius:10, padding:14, position:"sticky", top:16 },
  sumLine: { display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:"0.5px solid rgba(255,255,255,0.05)" },
  pill:    { display:"inline-block", fontSize:10, fontWeight:500, padding:"3px 10px", borderRadius:999, background:"rgba(26,158,114,0.12)", color:"var(--accent)", border:"1px solid rgba(26,158,114,0.25)", marginTop:8 },
  trialBox:{ marginTop:10, background:"#0d1f17", border:"0.5px solid rgba(26,158,114,0.15)", borderRadius:8, padding:"8px 10px", fontSize:11, color:"#9ca3af", lineHeight:1.6 },
  warnBox: { marginTop:8, display:"flex", gap:8, background:"#1a1206", border:"0.5px solid rgba(186,117,23,0.25)", borderRadius:8, padding:"8px 10px" },
};

export default function Tarifs() {
  const [activeModules, setActiveModules] = useState(new Set());
  const [extraUsers,    setExtraUsers]    = useState(0);
  const [billing,       setBilling]       = useState("monthly");
  const [satellite,     setSatellite]     = useState(false);
  const [groupe,        setGroupe]        = useState(false);
  const [satCount,      setSatCount]      = useState(1);
  const [activeProfile, setActiveProfile] = useState(null);

  const toggleModule = (id) => {
    setActiveModules(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const applyProfile = (name) => {
    setActiveProfile(name);
    setActiveModules(new Set(PROFILES[name] ?? []));
  };

  const { totalMonthly, summaryLines, annualSaving } = useMemo(() => {
    const modCost    = MODULES.filter(m => activeModules.has(m.id)).reduce((s,m) => s+m.price, 0);
    const usersCost  = extraUsers * USER_PRICE;
    const satCost    = satellite ? SAT_PRICE * satCount : 0;
    const grpCost    = groupe    ? GRP_PRICE : 0;
    const base       = SOCLE + modCost + usersCost + satCost;
    let total, saving = 0;
    if (billing === "annual") {
      total  = Math.round((base * 10 + grpCost * 12) / 12);
      saving = Math.round(base * 2);
    } else {
      total = base + grpCost;
    }
    const lines = [
      { label:"Socle (3 utilisateurs inclus)", value:`${SOCLE} €` },
      ...(extraUsers > 0 ? [{ label:`+ ${extraUsers} utilisateur${extraUsers>1?"s":""} suppl.`, value:`${extraUsers*USER_PRICE} €` }] : []),
      ...MODULES.filter(m => activeModules.has(m.id)).map(m => ({ label:m.name, value:`${m.price} €` })),
      ...(satellite ? [{ label:`Entités satellites (×${satCount})`, value:`${SAT_PRICE * satCount} €` }] : []),
      ...(groupe    ? [{ label:"Vue Groupe & Consolidation"+(billing==="annual"?" (×12)":""), value:`${GRP_PRICE} €` }] : []),
    ];
    return { totalMonthly:total, summaryLines:lines, annualSaving:saving };
  }, [activeModules, extraUsers, billing, satellite, groupe, satCount]);

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <h1 style={S.title}>Simulateur de tarifs</h1>
        <div style={S.toggle}>
          <button style={billing==="monthly"?S.btnOn:S.btnOff} onClick={()=>setBilling("monthly")}>Mensuel</button>
          <button style={billing==="annual"?S.btnOn:S.btnOff}  onClick={()=>setBilling("annual")}>Annuel — 2 mois offerts</button>
        </div>
      </div>

      <span style={S.label}>Suggestion par profil</span>
      <div style={S.profiles}>
        {Object.keys(PROFILES).map(p => (
          <button key={p} style={activeProfile===p?S.profOn:S.profOff} onClick={()=>applyProfile(p)}>{p}</button>
        ))}
      </div>

      <div style={S.grid}>
        <div>
          <span style={S.label}>Socle obligatoire</span>
          <div style={S.card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
              <span style={{ fontSize:13, color:"var(--text-primary)" }}>Socle · 3 utilisateurs inclus</span>
              <span style={{ fontSize:14, fontWeight:500, color:"var(--accent)" }}>39 € HT/mois</span>
            </div>
            <p style={{ fontSize:11, color:"var(--text-muted)", margin:0 }}>Facturation, Compta, FEC, Trésorerie, Facturation électronique Factur-X/UBL, Relances, Tableau de bord, Sécurité</p>
          </div>

          <div style={{ ...S.card, display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:13, color:"var(--text-primary)", flex:1 }}>
              Utilisateurs supplémentaires <span style={{ fontSize:11, color:"var(--text-muted)" }}>(9 € HT/mois · max {MAX_EXTRA})</span>
            </span>
            <input type="range" min={0} max={MAX_EXTRA} step={1} value={extraUsers}
              onChange={e=>setExtraUsers(Number(e.target.value))}
              style={{ width:90, accentColor:"#1a9e72" }} />
            <span style={{ fontSize:13, fontWeight:500, color:"var(--accent)", minWidth:20, textAlign:"right" }}>{extraUsers}</span>
          </div>

          <span style={S.label}>Modules à la carte</span>
          <div style={S.modGrid}>
            {MODULES.map(m => {
              const on = activeModules.has(m.id);
              return (
                <button key={m.id} style={on?S.modOn:S.modOff} onClick={()=>toggleModule(m.id)}>
                  <div style={on?S.chkOn:S.chkOff}>
                    {on && <i className="ti ti-check" style={{ fontSize:10, color:"#fff" }} />}
                  </div>
                  <span style={{ flex:1, fontSize:12, color:on?"#E2E8EF":"var(--text-muted)", textAlign:"left" }}>{m.name}</span>
                  <span style={{ fontSize:11, color:on?"var(--accent)":"var(--text-muted)", flexShrink:0 }}>{m.price} €</span>
                </button>
              );
            })}
          </div>

          <span style={{ ...S.label, marginTop:16 }}>Multi-entités</span>
          <div style={S.card}>
            {[
            { key:"sat", label:"Entités satellites", sub:"23 € HT/mois par société (−41% sur le socle)", val:satellite, set:setSatellite },
              { key:"grp", label:"Vue Groupe & Consolidation", sub:"59 € HT/mois — exclu remise annuelle, facturé ×12", val:groupe, set:setGroupe },
            ].map(({ key, label, sub, val, set }) => (
              <div key={key} style={{ display:"flex", alignItems:"center", gap:12, padding:"8px 0", borderBottom:key==="sat"?"1px solid var(--border)":"none" }}>
                <div style={{ flex:1 }}>
                  <p style={{ fontSize:12, color:"var(--text-primary)", margin:0 }}>{label}</p>
                  <p style={{ fontSize:11, color:"var(--text-muted)", margin:"2px 0 0" }}>{sub}</p>
                </div>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  {key==="sat" && satellite && (
                    <>
                      <input type="number" min={1} max={20} value={satCount} step={1}
                        style={{ width:52, padding:"4px 8px", background:"#181C20", border:"0.5px solid rgba(255,255,255,0.15)", borderRadius:6, color:"#E2E8EF", fontSize:13, textAlign:"center" }}
                        onChange={e => setSatCount(Math.min(20, Math.max(1, parseInt(e.target.value)||1)))} />
                      <span style={{ fontSize:11, color:"var(--text-muted)" }}>soc.</span>
                    </>
                  )}
                  <button onClick={()=>set(v=>!v)} style={{ width:34, height:18, borderRadius:999, border:"none", cursor:"pointer", background:val?"var(--accent)":"var(--border)", position:"relative", flexShrink:0, transition:"background .15s" }}>
                    <span style={{ position:"absolute", top:2, left:val?18:2, width:14, height:14, borderRadius:"50%", background:"#fff", transition:"left .15s" }} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <span style={S.label}>Récapitulatif</span>
          <div style={S.sumCard}>
            {summaryLines.map((l,i) => (
              <div key={i} style={{ ...S.sumLine, borderBottom: i===summaryLines.length-1?"none":"0.5px solid rgba(255,255,255,0.05)" }}>
                <span style={{ fontSize:11, color:"#9ca3af" }}>{l.label}</span>
                <span style={{ fontSize:11, color:"#E2E8EF" }}>{l.value}</span>
              </div>
            ))}
            <div style={{ marginTop:12, paddingTop:12, borderTop:"0.5px solid rgba(255,255,255,0.1)" }}>
              <p style={{ fontSize:11, color:"#9ca3af", margin:"0 0 4px" }}>Total estimé HT</p>
              <p style={{ fontSize:24, fontWeight:500, color:"var(--accent)", margin:0, lineHeight:1 }}>{totalMonthly} €</p>
              <p style={{ fontSize:11, color:"#9ca3af", margin:"4px 0 0" }}>
                {billing==="annual" ? "/mois · facturé annuellement" : "/mois"}
              </p>
              {billing==="annual" && annualSaving>0 && (
                <span style={S.pill}>Économie : {annualSaving} € / an</span>
              )}
            </div>
            <div style={S.trialBox}>
              <span style={{ color:"var(--accent)", fontWeight:500 }}>14 jours d'essai gratuits</span>
              {" "}— aucune carte bancaire. Extension à 30 jours sur demande.
            </div>
            <div style={S.warnBox}>
              <i className="ti ti-alert-triangle" style={{ color:"#EF9F27", fontSize:14, flexShrink:0, marginTop:1 }} />
              <p style={{ fontSize:11, color:"#9ca3af", margin:0, lineHeight:1.6 }}>
                Période entamée due intégralement, sans prorata.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
